module.exports = __webpack_public_path__ + "img/fingerprint.2fe862c5.svg";